














import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { CommentView, CommentAdd, CommentEdit, isCommentEdit } from '../store/models';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Actions as CommentsActions} from '@/modules/comments/store/actions';
import { commentsModuleName } from '@/modules/comments/store';
const commentsModule = namespace(commentsModuleName);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class EditCommentModal extends Vue {

  @commentsModule.Action(CommentsActions.ADD_COMMENT) private addComment!: (newComment: CommentAdd) => void;
  @commentsModule.Action(CommentsActions.EDIT_COMMENT) private editComment!: (commentEdit: CommentEdit) => void;

  @Prop() private id!: string;
  @Prop() private comment!: CommentAdd | CommentEdit;

  private $auth: any = (this as any).$auth;
  private isBusy: boolean = false;
  private text: string = '';
  private userName: string = '';

  get isEditMode() {
    return isCommentEdit(this.comment);
  }

  get okTitle() {
    return this.isEditMode ? 'Zapisz' : 'Wyślij';
  }

  get modalTitle() {
    return this.isEditMode ? 'Edycja komentarza' : 'Nowy komentarz';
  }

  get textIsEmpty() {
    return !(this.text.length > 0);
  }

  private handleOk(bvModalEvt: any) {
    bvModalEvt.preventDefault();
    this.handleSubmit();
  }

  private async handleSubmit() {
    this.isBusy = true;
    if (this.isEditMode) {
      const commentEdit = this.comment as CommentEdit;
      commentEdit.text = this.text;
      await this.editComment(commentEdit);
    } else {
      const commentAdd = this.comment as CommentAdd;
      commentAdd.text = this.text;
      commentAdd.userName = commentAdd.userName ?
                            commentAdd.userName :
                            this.userName ? '~' + this.userName : '~Gość';
      await this.addComment(commentAdd);
    }
    this.$nextTick(() => {(this.$refs.modal as any).hide(); });
    this.$emit('saveSucceeded');
    this.resetModal();
  }

  private onShow() {
    this.resetModal();
    this.text = this.comment.text;
  }

  private onShown() {
    (this.$refs.textInput as any).$el.focus();
  }

  private resetModal() {
    this.text = '';
    this.userName = '';
    this.isBusy = false;
  }

}
